module.exports = __webpack_public_path__ + "static/img/20017 (5).6656e3c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (5).webp
// module id = QVeg
// module chunks = 14